module.exports = __webpack_public_path__ + "static/media/quote-indeed-communication.69bd8b8d.png";